import { render, staticRenderFns } from "./EduClass.vue?vue&type=template&id=45d49e4f&scoped=true"
import script from "./EduClass.vue?vue&type=script&lang=js"
export * from "./EduClass.vue?vue&type=script&lang=js"
import style0 from "./EduClass.vue?vue&type=style&index=0&id=45d49e4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d49e4f",
  null
  
)

export default component.exports